// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { put } from '@tls/auth';
import { QCResult } from 'components/project/data/filter/filters-defaults';
import { extractLabels } from 'components/project/data/utils';
import { blobToBase64 } from 'components/treactui-template/meta/loadImageIntoElement';
import { useState } from 'react';

export default function useUploadApi(projectId: string) {
  const [uploading, setUploading] = useState(false);

  async function uploadFile(original: File, previewImage: File) {
    setUploading(true);
    const formData = new FormData();
    formData.append('uploadedFiles', original);
    formData.append('uploadedFiles', previewImage);

    const result = await put(`projects/${projectId}/labels/image`, formData, false, false, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    setUploading(false);
    return result;
  }

  async function uploadMask(mask: File, imageMd5: string, isValidation: boolean, qcResult: QCResult) {
    setUploading(true);
    const formData = new FormData();
    formData.append('uploadedFile', mask);

    const base64 = await blobToBase64(mask);
    if (base64 === null) {
      setUploading(false);
      return;
    }
    const labels = await extractLabels(base64);

    const metaData = {
      usedLabels: labels,
      validationData: isValidation,
      qcResult: qcResult,
    };
    formData.append('metaData', JSON.stringify(metaData));

    const result = await put(`projects/${projectId}/labels/${imageMd5}/mask`, formData, false, false, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    setUploading(false);
    return result;
  }

  async function uploadPreviewImage(preview: File) {
    setUploading(true);
    const formData = new FormData();
    formData.append('uploadedFile', preview);

    const result = await put(`projects/${projectId}/previewImage`, formData, false, false, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    setUploading(false);
    return result;
  }

  return { loading: uploading, uploadFile, uploadMask, uploadPreviewImage };
}
